import React, { useEffect } from 'react'
import DynamicSVG from '../DynamicSVG/DynamicSVG'
import { useState,useId} from 'react'
import "../ToastsList/ToastsList.css"
import Toast from './Toast/Toast'
import ReactDOM from 'react-dom'
import {CSSTransition, TransitionGroup} from "react-transition-group"
type Props = {
  toastsArr: toastObj[]
  autoDelete?: boolean
  autoDeleteTime?: number,
  deleteToast:((id:number)=> void)
}
interface toastObj{
  id:number,
  title: string,
  description: string,
}
export default function Toastlist({ toastsArr, autoDelete, autoDeleteTime = 3000 ,deleteToast}: Props) {
  const ToastID = useId()
  const [state, setstate] = useState<{
    toastsArr:toastObj[]
  }>({
    toastsArr:toastsArr
  })
  useEffect(() => {
    setstate({toastsArr:toastsArr})
  },[toastsArr])
  
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (autoDelete == true && state.toastsArr.length > 0) {
        if (state.toastsArr[0].id) deleteToast(state.toastsArr[0].id)
      }
    },autoDeleteTime);
    return () => {
      clearTimeout(timeout)
    }
    
  }, [state.toastsArr])
  
  return ReactDOM.createPortal(
   
    <ul className='Toasts-Main-Container'>
      <TransitionGroup className="Toasts-Container">
        {
          state.toastsArr.map((toastObj, i) => {
            return <CSSTransition key={i} timeout={1000} classNames={"Toast"}>
              <Toast
            startAnimation={true}
            id={toastObj.id}
            animationDelay={i}
            key={toastObj.id}
            title={toastObj.title}
            description={toastObj.description}
            deleteCallback={deleteToast}
          />
            </CSSTransition>
        })
      }
       </TransitionGroup>
        
    </ul>
  ,document.getElementById("root") as HTMLElement)
}